import { EvaluateRuleSetRequest, RULE_SET_ROUTES } from "@zeal/common";
import { IAxiosInstance } from "../../../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../../../AbstractApiClient/IApiResponse";

export const evaluateRuleSet = (axios: IAxiosInstance) => {
  return async (data: EvaluateRuleSetRequest) => {
    const response = await axios.noRetry.post<IApiResponse<any>>(
      `${RULE_SET_ROUTES.EVALUATE_RULE_SET.replace(
        ":companyID",
        data.companyID
      ).replace(":ruleSetID", data.ruleSetID)}`,
      data
    );

    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
